export default __webpack_public_path__ + "static/media/copy.c6164e67.svg";